module.exports = __webpack_public_path__ + "img/Elements_Icons_End-Use Monthlys.90edaa3b.png";